// extracted by mini-css-extract-plugin
export default {"bodyContainer":"Manuals_bodyContainer__mLLEa","leftNavigation":"Manuals_leftNavigation__d2d3x","rightContent":"Manuals_rightContent__UzkN-"};